import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { NekoTypo } from '../misc/Typography';

const Block = Styled.div`
  font-size: ${Theme.fontSizeText};
  background-color: ${Theme.white};
  padding: 8px;

  .nui-block-title {
    color: ${Theme.blue};
    padding: 5px 10px;
    margin-bottom: 5px;
  }

  .nui-block-content {
    background-color: ${Theme.lightBlue};
    border-top: 1px solid ${Theme.blue};
    padding: 26px;
  }

  &.primary {
    background-color: ${Theme.blue};

    .nui-block-title {
      color: ${Theme.white};
    }

    .nui-block-content {
      background-color: ${Theme.white};
    }
  }
`;

/**
 * @oaram {string} className
 */
const StyledNekoBlock = props => {

  const { title, children, className, style = {} } = props;

  return (
    <Block className={className || ''} style={style}>
      <NekoTypo h2 className="nui-block-title">{title}</NekoTypo>
      <div className="nui-block-content">
        { children }
      </div>
    </Block>
  );
};

const NekoBlock = (props) => {
  return (<StyledNekoBlock {...props} />);
}

NekoBlock.propTypes = {
  title: PropTypes.string,
  className: PropTypes.oneOf(['', 'primary']),
  style: PropTypes.object
};

NekoBlock.defaultProps = {
  title: undefined,
  className: '',
  style: {}
};

export { NekoBlock };
